export default "__VITE_ASSET__BrKzZbR2__"